export const onCreateSimulationMessage = /* GraphQL */ `
  subscription OnCreateSimulationMessage(
    $filter: ModelSubscriptionSimulationMessageFilterInput
  ) {
    onCreateSimulationMessage(filter: $filter) {
      id
      body
      userId
      sender
      simulationId
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateCampaign = /* GraphQL */ `
  subscription OnUpdateCampaign(
    $filter: ModelSubscriptionCampaignFilterInput
    $owner: String
  ) {
    onUpdateCampaign(filter: $filter, owner: $owner) {
      id
      agentId
      userId
      organizationId
      status
      type
      title
      outreachDescription
      jobDescription
      jobDescriptionText
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        summaryOfRole
        contractType
      }
      additionalContext
      questions {
        content
        isMandatory
        documentTypes
        questionType
        hasPreferredAnswer
        preferredAnswerRequirements
        preferredAnswerText
        expectedAnswer
        order
      }
      meetingUrl
      contactNumber
      customRequest
      csvS3Key
      closingMethod
      closingMessage
      templateId
      webChatTemplateId
      candidateBatchId
      atsJobId
      atsJobPostingId
      totalProspectsCount
      totalConversationsCount
      totalConversationsWithRepliesCount
      initialMessagesSentCount
      totalMessagesCount
      totalMessagesWithMeetingUrlCount
      totalMessagesWithCallRequest
      totalMessagesWithCustomRequest
      initialMessagesDeliveredCount
      initialMessagesUndeliveredCount
      initialMessagesReadCount
      messagesProcessedCount
      timeToAutoCloseConversationsInHours
      launchScheduleDateTime
      rejectionMessage
      createdAt
      channel
      owner
      needsReview
      averageTimeToFirstResponse
      averageTimeToComplete
      updatedAt
      externalId
    }
  }
`;

export const onUpdateCampaignStats = /* GraphQL */ `
  subscription OnUpdateCampaignStats($id: ID!) {
    onUpdateCampaignStats(id: $id) {
      id

      totalProspectsCount
      totalConversationsCount
      totalConversationsWithRepliesCount
      initialMessagesSentCount
      totalMessagesCount
      totalMessagesWithMeetingUrlCount
      totalMessagesWithCallRequest
      totalMessagesWithCustomRequest
      initialMessagesDeliveredCount
      initialMessagesUndeliveredCount
      initialMessagesReadCount
      messagesProcessedCount
    }
  }
`;
